import { useViewState } from "../lib/view-state.js";
import "./Scrubber.css";

/** The time-machine control shared by all views. */
export function Scrubber() {
  const { asOf, setAsOf, shift, reset } = useViewState();
  const isToday = asOf === new Date().toISOString().slice(0, 10);
  return (
    <div className="scrub">
      <button
        type="button"
        className="scrub__arrow"
        aria-label="previous day"
        onClick={() => shift(-1)}
      >
        ‹
      </button>
      <input
        type="date"
        className="scrub__date"
        aria-label="date"
        value={asOf}
        onChange={(e) => e.target.value && setAsOf(e.target.value)}
      />
      <button type="button" className="scrub__arrow" aria-label="next day" onClick={() => shift(1)}>
        ›
      </button>
      {!isToday && (
        <button type="button" className="scrub__today" onClick={reset}>
          Today
        </button>
      )}
    </div>
  );
}
